import {ConnectionBackend, Http, Request, RequestOptions, RequestOptionsArgs, Response} from '@angular/http';
import {Observable} from 'rxjs';
import {ErrorObservable} from 'rxjs/observable/ErrorObservable';


export abstract class MutableHttp extends Http {

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions) {
        super(backend, defaultOptions);
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return super.request(url, this.modifyOptions(options))
            .map(this.modifyResponseCallback())
            .catch(this.modifyResponseErrorCallback());
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return super.get(url, this.modifyOptions(options)).map(this.modifyResponseCallback());
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return super.post(url, body, this.modifyOptions(options)).map(this.modifyResponseCallback());
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return super.put(url, body, this.modifyOptions(options)).map(this.modifyResponseCallback());
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return super.delete(url, this.modifyOptions(options)).map(this.modifyResponseCallback());
    }

    patch(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        return super.patch(url, body, this.modifyOptions(options)).map(this.modifyResponseCallback());
    }

    protected abstract modifyOptions(options?: RequestOptionsArgs): RequestOptionsArgs;

    protected modifyResponseCallback(): (response: Response) => Response {
        return (response: Response) => response;
    }

    protected modifyResponseErrorCallback(): (response: Response) => ErrorObservable {
        return (response: Response) => Observable.throw(response);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/core/http/mutable.http.ts